/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Project_Data_Processing_StatusInputs */



/**
* | output |
* | --- |
* | "Processing project data..." |
*
* @param {Iframe_Remote_Project_Data_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_project_data_processing_status = /** @type {((inputs?: Iframe_Remote_Project_Data_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Project_Data_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement des donnees du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung der Projektdaten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione dei dati del progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка проектных данных...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando datos del proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理项目数据……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト データを処理しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट डेटा संसाधित किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processando dados do projeto...")
	return /** @type {LocalizedString} */ ("Processing project data...")
});